import request from '@/shared/api/request';

export const deleteDomainRecord = (domain_name: string, record_id: number): Promise<void> =>
  request({
    url: `/domains/${domain_name}/records/${record_id}`,
    method: 'DELETE',
  });
